import React from 'react';
import { WorkflowEventDefinition } from '../../../services/legacyApi';

type StatusGuidePanelProps = {
    statusLabel: string;
    statusMeaning?: string;
    nextActions: WorkflowEventDefinition[];
};

export const StatusGuidePanel: React.FC<StatusGuidePanelProps> = ({
    statusLabel,
    statusMeaning,
    nextActions,
}) => {
    return (
        <div className="space-y-3 rounded-md border bg-slate-50 p-4">
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Current Status</p>
                <p className="text-sm font-semibold text-foreground">{statusLabel}</p>
            </div>
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Meaning</p>
                <p className="text-sm text-foreground">{statusMeaning || 'No status guidance available.'}</p>
            </div>
            <div>
                <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">What Happens Next</p>
                {nextActions.length === 0 ? (
                    <p className="text-sm text-muted-foreground">This status has no next actions.</p>
                ) : (
                    <ul className="space-y-1 text-sm">
                        {nextActions.map((action) => (
                            <li key={action.event_code} className="text-foreground">
                                <span className="font-medium">{action.event_label}</span>
                                {action.to_status_label ? ` -> ${action.to_status_label}` : ''}
                                {action.event_description ? `: ${action.event_description}` : ''}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

